import { useMemo, useEffect } from "react";
import { useQuery } from "react-query";
import { useParams, Link } from "react-router-dom";
import apiService from "services/api";
import StudentDetailTab from "./Tabs/StudentDetails";
import StudentSummary from "./Tabs/StudentSummary";
import { CustomTabs, Backdrop } from "components";
import { useNotificationContext } from "contexts";
import LessonRecords from "./Tabs/LessonRecords";
import StudentCourses from "./Tabs/StudentCourses";
import { FiLoader } from "react-icons/fi";
import PreviousLessonRecords from "./Tabs/PreviousLessonRecords";
import ParentMeeting from "./Tabs/ParentMeeting";

const ViewStudentPage = () => {
  const { createNotification } = useNotificationContext();
  const { student_id } = useParams();
  const {
    data: student,
    isLoading,
    refetch,
    isFetching,
  } = useQuery(
    ["student", student_id],
    () => apiService.student.getLeanV2(student_id),
    { enabled: Boolean(student_id) },
  );

  useEffect(() => {
    if (student?.courses?.length) {
      student?.courses?.forEach((course) => {
        if (course.hoursLeft < 6) {
          createNotification({
            type: "info",
            message: `INFO: ${course.courseDetail?.name} has ${course.hoursLeft} hours left!`,
          });
        }
      });
    }
  }, [student]);

  const tabs = useMemo(
    () => [
      {
        title: "Student Details",
        component: () => <StudentDetailTab student={student} />,
      },
      {
        title: "Courses",
        component: () => <StudentCourses student={student} refetch={refetch} />,
      },
      {
        title: "Lesson Records",
        component: () => <LessonRecords student={student} />,
      },
      {
        title: "Previous Lesson Records",
        component: () => <PreviousLessonRecords student={student} />,
      },
      {
        title: "Summary",
        component: () => <StudentSummary student={student} />,
      },
      {
        title: "Parent Meetings",
        component: () => <ParentMeeting student={student} />,
      },
    ],
    [student],
  );

  return (
    <div className="content">
      <div className="d-flex mb-5">
        <Link to={`/student`}>
          <button className="btn btn-sm btn-info text-nowrap">&lt; Back</button>
        </Link>
      </div>
      <h4>
        <b>{student?.firstName + " " + student?.lastName}</b>
      </h4>
      <Backdrop open={isFetching} fitToParent={true}>
        <div className="text-center position-absolute">
          <FiLoader size={40} className="animate-spin" />
        </div>
      </Backdrop>
      <CustomTabs tabs={tabs} />
    </div>
  );
};

export default ViewStudentPage;
